import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';
import { GlobalService } from 'src/app/services/global/global.service';
import { ApiHelperService } from 'src/app/services/api-helper-service/api-helper.service';

@Component({
  selector: 'app-client-support-modal',
  templateUrl: './client-support-modal.component.html',
  styleUrls: ['./client-support-modal.component.scss'],
})
export class ClientSupportComponent implements OnInit {

  whatsappBaseUrl = environment.supportFeature.sendWhatsappBaseUrl;
  supportEmail = environment.supportFeature.supportEmail;
  supportWhatsapp = environment.supportFeature.supportWhatsapp;
  userMessage: string = '';
  page: 'home' | 'email' | 'whatsapp' | 'end' = 'home';
  userId: any;
  userMobileNo : any;
  userEmail : any;
  userName: any;
  userIdentityNo: any;
  officeId: any;
  preferredBranch: string;
  supportChannel: any;
  constructor(
    private modalCtrl: ModalController,
    private userService : UserService,
    private globalService: GlobalService,
    private apiHelperService: ApiHelperService,
  ) { }

  async ngOnInit() {
    const userStorage: any = await this.userService.getUserStorage();

    this.userMobileNo = Number(userStorage.mobileNo);
    this.userEmail = userStorage.email;
    this.userName = userStorage.fullName;
    this.userId = userStorage.userId;
    this.userIdentityNo = userStorage.identityNo;
    this.officeId = userStorage.officeId;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  goBack() {
    this.page = 'home'; // back to main modal view
  }

  getModalClassForStep(page: string) {
    switch (page) {
      case 'home':
        return 'client-support-modal';
      case 'email':
      case 'whatsapp':
        return 'client-support-content-modal';
      case 'end' :
        return 'client-support-modal';
      default:
        return 'client-support-modal';
    }
  }

  setStep(newPage: any) {
    this.page = newPage;
    const modalEl = document.querySelector('ion-modal');
    if (modalEl) {
      modalEl.classList.remove('client-support-modal', 'client-support-content-modal');
      modalEl.classList.add(this.getModalClassForStep(newPage));
    }
  }

  async sendEmailMessage() {
    await this.saveClientSupport('Email');
    const receiver = encodeURIComponent(this.supportEmail);
    const subject = encodeURIComponent(`Support - Yayasan Hijrah Selangor`);
    const body = encodeURIComponent(
    `Hi YHS,

I need your assistance. Here's my detail

    Name: ${this.userName}
    Email: ${this.userEmail}
    Phone: ${this.userMobileNo}
    Issue: ${this.userMessage}

Thank you!`);

      const mailtoUrl = `mailto:${receiver}?subject=${subject}&body=${body}`;
      window.location.href = mailtoUrl;
      this.setStep('end');
  }

  async sendWhatsappMessage() {
    await this.saveClientSupport('Whatsapp');
    const message = encodeURIComponent(
    `Hi YHS,

I need your assistance. Here's my detail

    *Name:* ${this.userName}
    *Email:* ${this.userEmail}
    *Phone:* ${this.userMobileNo}
    *Issue:* ${this.userMessage}

Thank you`);

    const url = `${this.whatsappBaseUrl}${this.supportWhatsapp}?text=${message}`;
    await Browser.open({ url });
    this.setStep('end');
  }

  async saveClientSupport(platform: any) {
    if (this.officeId) {
      const office = await this.getOfficeNameByOfficeId(this.officeId);
      this.preferredBranch = office.name;
    } else {
      this.preferredBranch = 'Head Office'
    }

    let payload : any;

    payload = {
      payload: {
        clientId : this.userId,
        clientName: this.userName,
        identityNo: this.userIdentityNo,
        phoneNumber: this.userMobileNo,
        email: this.userEmail,
        clientInquiry: this.userMessage,
        status: 'OPEN',
        prefferedBranch: this.preferredBranch,
        channel: platform
      },
      referenceNumber: this.globalService.generateUUID(),
      username: this.globalService.username,
      channelId: this.globalService.channelId,
      officeId: this.officeId
    };

    const saveClientSupport = await this.apiHelperService.createClientSupport(payload);
    console.log(saveClientSupport);
  }

    async getOfficeNameByOfficeId(id: string | number): Promise<any> {
    try {
      const searchPayload = {
        filter: JSON.stringify({
          where: { id },
          fields: ['id', 'name']
        }),
        referenceNumber: this.globalService.generateUUID(),
        username: this.globalService.username,
        channelId: this.globalService.channelId
      };

      const searchResponse = await this.apiHelperService.getOffice(searchPayload);
      console.log('searchResponse: ', searchResponse);

      const officeData = searchResponse?.data?.office;

      if (Array.isArray(officeData) && officeData.length > 0) {
        return officeData[0];
      } else {
        console.error('No office found for the given officeId');
        return null;
      }
    } catch (err) {
      throw err;
    }
  }
}
